import { Routes } from '@angular/router';
import { AppRoutesEnum } from '../../@core/enum/appRoutes';
import { authLayoutRoutes } from './authentication-layout/authentication-layout.route';

export const authRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('../../modules/authentication/authentication.component').then((m) => m.AuthenticationComponent),
    children: [
      {
        path: AppRoutesEnum.ROLE_SELECTOR,
        loadComponent: () =>
          import('../../modules/authentication/role-selector/role-selector.component').then((m) => m.RoleSelectorComponent),
      },
      {
        path: 'sign-up',
        loadComponent: () =>
          import('../../modules/authentication/signup/signup.component').then((m) => m.SignupComponent),
      },
      {
        path: AppRoutesEnum.EMPTY,
        children: authLayoutRoutes,
      },
    ],
  },
];